export const EXCMDAILYPLAN_CREATE_RESET = 'EXCMDAILYPLAN_CREATE_RESET'
export const EXCMDAILYPLAN_CREATE_SET_CREATED = 'EXCMDAILYPLAN_CREATE_SET_CREATED'
export const EXCMDAILYPLAN_CREATE_SET_ERROR = 'EXCMDAILYPLAN_CREATE_SET_ERROR'
export const EXCMDAILYPLAN_CREATE_SET_VIOLATIONS = 'EXCMDAILYPLAN_CREATE_SET_VIOLATIONS'
export const EXCMDAILYPLAN_CREATE_TOGGLE_LOADING = 'EXCMDAILYPLAN_CREATE_TOGGLE_LOADING'
